import PropTypes from 'prop-types';
import { Component } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { connect } from 'react-redux';
import { editEmailAddress } from '../actions/EmailAddressActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import { getEditEmailAddressModalOpen } from '../selectors/InteractionSelector';
import { getHubUsers } from '../selectors/HubUsersSelector';
import { toggleEditEmailAddressModalOpen } from '../actions/AppActions';
import EditEmailAddressModal from '../components/EditEmailAddressModal';
import { trackScreen } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
class EditEmailAddressModalContainer extends Component {
  constructor(props) {
    super(props);
    this.onStagePassword = password => {
      this.setState({
        stagedPassword: password
      });
    };
    this.state = {
      stagedPassword: '',
      stagedNewEmailAddress: '',
      hasConflict: false,
      validEmail: true,
      emailInputFocused: false
    };
    this.onStagedNewEmailAddressChanged = this.onStagedNewEmailAddressChanged.bind(this);
    this.onSaveNewEmailAddress = this.onSaveNewEmailAddress.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      editEmailAddressModalOpen
    } = this.props;
    if (editEmailAddressModalOpen && !prevProps.editEmailAddressModalOpen) {
      trackScreen('edit-email-address-modal');
    }
  }
  handleKeyUp(evt) {
    const {
      stagedNewEmailAddress,
      hasConflict,
      validEmail
    } = this.state;
    if (evt.keyCode === 13 && !hasConflict && stagedNewEmailAddress.length > 0 && validEmail) {
      this.onSaveNewEmailAddress();
    }
  }
  handleFocus() {
    this.setState({
      emailInputFocused: true
    });
  }
  handleBlur() {
    this.setState({
      emailInputFocused: false
    });
  }
  onStagedNewEmailAddressChanged(emailAddress) {
    this.setState({
      stagedNewEmailAddress: emailAddress,
      validEmail: emailAddress === '' ? true : EmailAddressPattern.test(emailAddress)
    });
  }
  onSaveNewEmailAddress() {
    const {
      stagedNewEmailAddress
    } = this.state;
    const hasConflict = this.props.hubUsers.some(user => user.get('email') === stagedNewEmailAddress);
    this.setState({
      hasConflict
    });
    if (!hasConflict) {
      const {
        stagedPassword
      } = this.state;
      this.props.editEmailAddress(stagedNewEmailAddress, stagedPassword);
      this.setState({
        stagedPassword: '',
        stagedNewEmailAddress: ''
      });
      this.props.toggleEditEmailAddressModalOpen();
    }
  }
  onCloseModal() {
    this.setState({
      stagedPassword: '',
      stagedNewEmailAddress: '',
      hasConflict: false,
      validEmail: true,
      emailInputFocused: false
    });
    this.props.toggleEditEmailAddressModalOpen();
  }
  render() {
    const {
      editEmailAddressModalOpen
    } = this.props;
    const {
      stagedPassword,
      stagedNewEmailAddress,
      hasConflict,
      validEmail,
      emailInputFocused
    } = this.state;
    if (editEmailAddressModalOpen) {
      return /*#__PURE__*/_jsx(EditEmailAddressModal, {
        stagedNewEmailAddress: stagedNewEmailAddress,
        onStagedNewEmailAddressChanged: this.onStagedNewEmailAddressChanged,
        stagedPassword: stagedPassword,
        onStagePasswordChange: this.onStagePassword,
        onSaveNewEmailAddress: this.onSaveNewEmailAddress,
        onCloseModal: this.onCloseModal,
        onKeyUp: this.handleKeyUp,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        hasConflict: hasConflict,
        validEmail: validEmail,
        emailInputFocused: emailInputFocused
      });
    }
    return null;
  }
}
EditEmailAddressModalContainer.propTypes = {
  editEmailAddressModalOpen: PropTypes.bool.isRequired,
  toggleEditEmailAddressModalOpen: PropTypes.func.isRequired,
  editEmailAddress: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  hubUsers: PropTypes.instanceOf(ImmutableMap).isRequired
};
const mapStateToProps = state => {
  return {
    editEmailAddressModalOpen: getEditEmailAddressModalOpen(state),
    hubUsers: getHubUsers(state)
  };
};
export default connect(mapStateToProps, {
  editEmailAddress,
  toggleEditEmailAddressModalOpen
})(EditEmailAddressModalContainer);